//packages blocks
import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
//common blocks
import { Sidebar, TopBar, DashboardRoutes } from "./components";
import "./dashboard.css";
//styles, utils, assets and api blocks

export const MainDashboard = () => {
  useEffect(() => {
    document.title = "Main Dashboard - Paynest";
  }, []);

  const [switchToggled, setSwitchToggled] = useState(false);

  const ToggleSwitch = () => {
    switchToggled ? setSwitchToggled(false) : setSwitchToggled(true);
  };

  // const myCallback = (result) => {
  // }

  // const onClickConnect = () => {
  //   window.Lean.connect({
  //     app_token: '535ecdd5-c4a2-4c7d-bb70-255df92ab047',
  //     customer_id: '000685d0-7129-4baf-ba9b-ce03fe841248',
  //     permissions: ['transactions', 'balance', 'identity', 'accounts', 'payments'],
  //     sandbox: 'true',
  //     payment_destination_id: '4bde9e71-0a3f-48e0-b146-4236c1f81dbd',
  //   })
  // }
  // const initiate = () => {
  //   window.Lean.pay({
  //     app_token: '535ecdd5-c4a2-4c7d-bb70-255df92ab047',
  //     payment_intent_id: "51bd4998-e63f-4dec-b963-1bdadf4ac5c5",
  //     sandbox: "true",
  //     callback: myCallback
  //   })
  // }

  return (
    <div className="dashboard-page">
      <Box style={{ minHeight: '100vh' }}>
        <div className={`sidebar-container ${switchToggled ? "show" : "hide"}`}>
          <Sidebar />
        </div>{" "}
      </Box>
      <div className="dashboard-main-container">
        <TopBar onCl={ToggleSwitch} />{" "}
        {/* <button onClick={() => onClickConnect()}>connect</button>
        <button onClick={() => initiate()}>initiate</button> */}
        <div className="main-content">
          <div className="centered-data">
            <DashboardRoutes />
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};

export default MainDashboard;
